module.exports = __webpack_public_path__ + "media/3.aef8de40.mp3";